import React, { useCallback, useEffect, useState } from "react";
import ReactImageAnnotate from "react-wound-image-annotate";
import style from "./measurement.module.scss";
import { Button, AccessErrorModal } from "../../../primary";
import "./measurement.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setWoundMeasurementData,
  getWoundMeasurements,
  ne1updateAssessmentNewMeasurementAsync,
  setNewWoundMeasurementStatus,
} from "../../../../app/patientSlice";
import { useParams } from "react-router-dom";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import Loader from "../../../../static/images/spinner.svg";
import { fullMonthFormatDate, signedLockedAccess, toLocalISOWithOffset } from "../../../../utils";
import iconDanger from "../../../../static/images/icon-check-danger.png";
import noWoundImage from "../../../../static/images/wound_image_not_process.png";
import { EDIT, SUCCESS_STATUS } from "../../../../constants";
import commonStyle from "../../../../styles/common.module.scss";
import { clearError } from "../../../../app/appSlice";
import infoIcon from "../../../../static/images/info.svg";
import { Confirmation } from "../../../secondary/Confirmation/confirmation";
import { Modal } from "../../../secondary";
import { MeasurementSidebar } from "./measurementSidebar";
import { MeasurementStatus } from "./measurementStatus";
import { MeasurementLoader } from "./measurementLoader";
import { EditMeasurement } from "./editMeasurement";
import constants from '../../../../constants/constants.json';
import Tooltip from "../../../secondary/Tooltip/tooltip";
import warning from "../../../../static/images/icon-check-danger.png";

export const Measurement = ({ hideIt }) => {
  const MAX_PENDING_RETRIES = 3;
  const dispatch = useDispatch();
  const { assessmentId, patientId } = useParams();

  const [measurementModal, setMeasurementModal] = useState(false);
  const [annotationView, setAnnotationView] = useState(false);
  const [measurementForm, setMeasurementForm] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [assessedPicture, setAssessedPicture] = useState(null);
  const [surfaceArea, setSurfaceArea] = useState(null);
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [editable, setEditable] = useState(false);
  const [formChangesConfirm, setFormChangesConfirm] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);
  const [pendingRetires, setPendingRetires] = useState(0);
  const [pendingTimer, setPendingTimer] = useState(15000);
  const [imageSrc, setImageSrc] = useState(null);
  const [isFallback, setIsFallback] = useState(false);
  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);
  const ne1getWounAssessmentDetailData = useSelector(state => state.patient.ne1getWounAssessmentDetail);
  const { loading, measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const appLoading = useSelector((state) => state.app.loading);
  const errorMessage = useSelector((state) => state.app.errorMessage);
  
const fetchMeasurements = useCallback(() => {
  const payload = {
    assessmentid: assessmentId,
    patientId,
  };
  dispatch(getWoundMeasurements(payload));
}, [assessmentId, patientId, dispatch]);


  useEffect(() => {
    fetchMeasurements();
  }, [fetchMeasurements]);

  // useEffect(() => {
  //   if (successMessage === SUCCESS_STATUS) {
  //     const timer = setTimeout(() => {
  //       fetchMeasurements();
  //       dispatch(setNewWoundMeasurementStatus(null));
  //     }, 5000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [dispatch, fetchMeasurements, successMessage]);

  useEffect(() => {
    let timer = null;

    if (measurementData?.status === "pending" && !assessmentDetail?.hasSkipMarker) {
      timer = setTimeout(() => {
        setPendingRetires((prev) => prev + 1);
        fetchMeasurements();
      }, pendingTimer);
    }

    return () => clearTimeout(timer);
  }, [assessmentDetail?.hasSkipMarker, fetchMeasurements, measurementData?.status, pendingTimer]);

  useEffect(() => {
    if (!measurementData?.intialImageSASURL) {
      setImageSrc(noWoundImage);
      setIsFallback(true);
      return
    }
  
    const img = new Image()
    img.src = measurementData.intialImageSASURL;
  
    img.onload = () => {
      setImageSrc(measurementData.intialImageSASURL);
      setIsFallback(false);
    }
  
    img.onerror = () => {
      setImageSrc(noWoundImage);
      setIsFallback(true);
    }
  }, [measurementData?.intialImageSASURL])

  /* auto measurement modal */
  const showMeasurementModal = (type) => {
    setMeasurementModal(true);
    if (type === "Dimensions") {
      setAnnotationView(false);
      setMeasurementForm(true);
    } else {
      setAnnotationView(true);
      setMeasurementForm(false);
    }
    setAssessedPicture(undefined);
  };

  // confirmation modal
  const confirmation = () => {
    if (document?.querySelector(".fullscreen") && document?.querySelector(".fullscreen svg > polygon")) {
      setConfirm(true);
    } else {
      assessModalClose();
    }
  };

  const assessModalClose = () => {
    setMeasurementModal(false);
    setAnnotationView(false);
    setConfirm(false);
    setMeasurementForm(false);
    dispatch(clearError());
  };

  const confirmationClose = () => {
    setConfirm(false);
  };

  useEffect(() => {
    setAssessedPicture(null);
    setSurfaceArea("");
    setLength("");
    setWidth("");
    dispatch(setWoundMeasurementData(null));
    dispatch(clearError());
  }, [dispatch, patientId, assessmentId]);

  useEffect(() => {
    if (measurementData?.assessedImageSASURL) {
      setAssessedPicture(`data:image/jpeg;base64,${measurementData?.assessedImageSASURL}`);
      setAnnotationView(false);
    } else {
      setAssessedPicture(null);
    }
  }, [measurementData]);

  const evalWound = (annotation) => {
    setAnnotationView(false);
    const { regions, pixelSize } = annotation.images[0];
    const pixelPoints = regions?.map(data => data?.points?.map(([x, y]) => ({
      x: x * pixelSize?.w,
      y: y * pixelSize?.h,
    })));
    const newWoundPayload = {
      blob_image: measurementData?.intialImageSASURL,
      depth_in_cm: 0,
      patient_id: patientId,
      assessment_id: assessmentId,
      wound_type: assessmentDetail?.isWoundWithoutPhoto === 1 ? "new_wound" : "existing_wound",
      camera_meta_data: null,
      device_details: null,
      common: {
        image_type: "primary",
        segment: pixelPoints?.length > 1 ? "multi_segment" : "single_segment",
        capture_status: "manual",
        user_selected_trace: true,
        arrow_to_toe: null,
        arrow_to_head: null,
        total_detections: {
          wound: 0,
          marker: 0,
        },
      },
      detections: null,
      wound_trace: pixelPoints,
      user_selected_segment: null,
      skip_marker: false,
      woundModifiedDate: toLocalISOWithOffset(new Date())
    };
    dispatch(ne1updateAssessmentNewMeasurementAsync(newWoundPayload));
    setPendingTimer(5000);
    setMeasurementModal(false);
  };

  /* State to check editable forms */
  // Edit state
  const confirmationCloseOver = () => {
    setConfirmationModal(false);
    setClickCancel(false);
    setEditBtn(false);
  };
  const yesConfirmationModalClick = () => {
    setConfirmationModal(false);
    setEditable(false);
    setFormChangesConfirm(false);
    setClickCancel(false);
    setEditBtn(true);
  };
  useEffect(() => {
    if (editable) {
      if (formChangesConfirm && clickCancel) {
        setConfirmationModal(true);
      } else if (clickCancel && formChangesConfirm === false) {
        setClickCancel(false);
        setConfirmationModal(false);
        setEditable(false);
        setEditBtn(true);
      }
    }
  }, [formChangesConfirm, clickCancel, editable]);

  const [editBtn, setEditBtn] = useState(true);
  const handleEdit = (edit, cancel) => {
    if (edit === "editable") {
      setEditable(true);
      setEditBtn(false);
    } else if (cancel === "cancel") {
      setClickCancel(true);
    } else {
      setEditable(false);
      setEditBtn(true);
    }
  };

  const nextDrawCall = () => {
    if (document?.querySelector(".next_draw")) {
      document.querySelector(".next_draw").click();
    }
  };
  const clearDrawCall = () => {
    if (document?.querySelector(".clear_draw")) {
      document.querySelector(".clear_draw").click();
    }
  };

  // <----Measurement Gif Loader when tracing without form populate----->
  const [retrace, setRetrace] = useState(false);
  useEffect(() => {
    if (retrace === true && measurementData !== null) {
      // setSaveClicked(true);
      setMeasurementForm(false);
      setMeasurementModal(false);
      if (editable) {
        setEditable(false);
        setEditBtn(true);
      }
    }
  }, [retrace, measurementData]);
  // <----Measurement Gif Loader----->

  return (
    <>
      {loading ? (
        <div className={`${"loader"} col-12`}>
          <img src={Loader} alt="loading" />
        </div>
      ) : (
        <>
          <div>
            {confirmationModal && (
              <Confirmation onClose={() => confirmationCloseOver()} title={" "}>
                <div className="text-center pr-5 pl-5">
                  <p>
                    <img src={iconDanger} alt="warnning-icon" />
                  </p>
                  <p className="pb-3">All progress in this section will be lost. Are you sure want to cancel?</p>
                  <div className="mb-2">
                    <Button
                      value="Yes"
                      classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${style.yes_btn}` }}
                      onClick={() => yesConfirmationModalClick()}
                    />
                    <Button
                      id="closeId"
                      value="No"
                      classes={{ className: `btn ml-2 pb-2 pt-2 ${style.no_btn}` }}
                      onClick={() => confirmationCloseOver()}
                    />
                  </div>
                </div>
              </Confirmation>
            )}
            <AccessErrorModal />

            {`${assessmentDetail?.id}` === assessmentId && (
              <div className="d-flex row no-gutters">
                <MeasurementSidebar hideIt={hideIt} showMeasurementModal={showMeasurementModal} setRetrace={setRetrace} />

                {assessmentDetail?.isWoundWithoutPhoto !== 1 && ne1getWounAssessmentDetailData?.isWoundPhoto === 0 ? (
                  <div className="col w-100 pl-4 pr-4 text-center">
                    <div className={style.btns_top_space}>
                      <div className={`mb-3 d-flex justify-content-center ${style.details_container}`}>
                        <img className={style.warning_icon} src={warning} alt="warnning-icon" />
                        {constants.assessment.missingWoundPhoto}
                      </div>
                    </div>
                  </div>
                ) : signedLockedAccess(assessmentDetail?.assessmentStage) &&
                  hideIt &&
                  assessmentDetail?.isWoundWithoutPhoto !== 1 &&
                  !assessmentDetail?.hasSkipMarker &&
                  measurementData?.status !== "success" ? (
                  <MeasurementStatus
                    showMeasurementModal={showMeasurementModal}
                    pendingRetires={pendingRetires}
                    maxPendingRetries={MAX_PENDING_RETRIES}
                  />
                ) : (
                  <div className="col-8 pt-4 pb-4">
                    <div className="w-100 pl-4 pr-4">
                      <div className="d-flex justify-content-between w-100 mb-4">
                        <div className={style.assess_heading}>
                          {measurementData?.measurementDate
                            ? fullMonthFormatDate(measurementData?.measurementDate)
                            : fullMonthFormatDate(assessmentDetail?.identifiedDate)}
                        </div>
                        <div>
                          {signedLockedAccess(assessmentDetail?.assessmentStage) && hideIt && editBtn && (
                            <div className={style.edit_btn} onClick={() => handleEdit("editable")}>
                              <img src={editIcon} alt="edit icon" /> {EDIT}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* editable form */}
                      {!editable && (
                        <div className={style.details_container}>
                          <div className={style.measure_surface}>
                            Surface Area:
                            <span className={`${style.cm_font} pl-1`}>
                              {measurementData?.surfaceArea && measurementData?.surfaceArea !== "Unknown" ? (
                                <span className="d-inline-flex">
                                  {`${measurementData?.surfaceArea} cm`}
                                  {assessmentDetail?.isWoundWithoutPhoto === 0 && (
                                    <sup>
                                      <b>2</b>
                                    </sup>
                                  )}
                                  {(assessmentDetail?.hasSkipMarker || assessmentDetail?.isWoundWithoutPhoto === 1) && (
                                    <Tooltip
                                      placement="right"
                                      className={style.tooltip}
                                      content={<>Surface area is auto-calculated using length <span style={{ fontWeight: "bold" }}>x</span> width formula</>}
                                    >
                                      <img src={infoIcon} alt="info" />
                                    </Tooltip>
                                  )}
                                </span>
                              ) : (
                                <span>{measurementData?.surfaceArea}</span>
                              )}
                            </span>
                          </div>

                          {[
                            { label: "Length", value: measurementData?.length, styleClass: style.measure_length },
                            { label: "Width", value: measurementData?.width, styleClass: style.measure_width },
                            { label: "Depth", value: measurementData?.depth, styleClass: style.measure_items },
                            { label: "Undermining", value: measurementData?.undermining, styleClass: style.measure_items },
                            { label: "Tunneling", value: measurementData?.tunneling, styleClass: style.measure_items },
                          ].map(({ label, value, styleClass }) => (
                            <div key={label} className={styleClass}>
                              {label}: <span className={style.cm_font}>{value && `${value} cm`}</span>
                            </div>
                          ))}
                        </div>
                      )}
                      {editable && (
                        <EditMeasurement
                          setFormChangesConfirm={setFormChangesConfirm}
                          handleEdit={handleEdit}
                          formChanges={true}
                          showCancel={true}
                          buttonClass={style.save_custom}
                          setMeasurementForm={setMeasurementForm}
                          setMeasurementModal={setMeasurementModal}
                          editable={editable}
                          setEditable={setEditable}
                          setEditBtn={setEditBtn}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* measurement modal */}
            {measurementModal && (
              <Modal
                modalOpen={true}
                modalClose={() => confirmation()}
                heading={measurementForm ? "Dimensions" : "Measurements"}
                className={"modal_box"}
                modalSize={style.custom_modal_size}
                confirmation={confirm}
                overlay={" "}
                overlay_class={confirm ? style.overlay_class : ""}
              >
                <div className={style.parent}>
                  {!appLoading && (
                    <>
                      {/* added for measurement git animation loader */}
                      <div className={`${style.button_Right} col-3 align-items-center  main_next_clear`}>
                        <div className={`${style.button_Right_Block}`}>
                          <Button value={"Next"} classes={{ className: `btn ml-4 mb-3 ${style.btn_add}` }} onClick={() => nextDrawCall()} />
                          <Button value="Clear" classes={{ className: `btn  ml-4 pt-2 ${style.no_btn_clr}` }} onClick={() => clearDrawCall()} />
                        </div>
                      </div>
                      {/* added for measurement git animation loader */}

                      <div className={`col-12 pl-4 pr-4 mb-4 sub_next_clear ${style.img_alert} text-center`}>
                        {annotationView && "Manually trace the wound edges to calculate the dimensions"}
                      </div>
                    </>
                  )}
                  <div id="wound" className={`row d-flex mb-4 ${style.annotate_container}`}>
                    {!appLoading && annotationView && (
                      <ReactImageAnnotate
                        selectedTool={isFallback ? "" : "create-polygon"}
                        onExit={(annotation) => {
                          if (!isFallback) {
                            evalWound(annotation)
                          }
                        }}
                        hideHeaderText
                        hideNext
                        hidePrev
                        showTags={false}
                        images={[
                          {
                            src: imageSrc,
                            regions: [],
                          },
                        ]}
                      />
                    )}

                    {/* added for measurement git animation loader */}
                    {appLoading && <MeasurementLoader />}

                    {/* added for measurement git animation loader */}
                    {!appLoading && !annotationView && !measurementForm && !assessedPicture && errorMessage && (
                      <div className="w-100 pl-4 pr-4 text-center">
                        <p>
                          <img src={iconDanger} alt="Error" />
                        </p>
                        <p className="pb-3"> {errorMessage} </p>

                        <div className="col-sm-12">
                          <div className="text-center pb-4">
                            <Button
                              type={"reset"}
                              value={"Ok"}
                              classes={{ className: `btn mr-4 ${commonStyle.btn_custom} ${commonStyle.btn_small}` }}
                              onClick={() => {
                                assessModalClose();
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {!appLoading && measurementForm && (
                      <div className="w-100 pl-4 pr-4 mt-2">
                        <EditMeasurement
                          setFormChangesConfirm={setFormChangesConfirm}
                          fieldDefaults={{ surfaceArea, length, width }}
                          buttonClass={`btn ${style.next_btn_sapce} ${style.btn_custom}`}
                          setMeasurementForm={setMeasurementForm}
                          setMeasurementModal={setMeasurementModal}
                          editable={editable}
                          setEditable={setEditable}
                          setEditBtn={setEditBtn}
                        />
                      </div>
                    )}
                  </div>
                  {confirm && (
                    <div className={style.confirmation_container}>
                      <div className={`${style.confirmation} d-flex align-items-center`}>
                        <div>All unsaved changes will be lost. Do you want to leave?</div>
                        <div>
                          <Button
                            type="button"
                            value="Yes"
                            classes={{ className: `btn ${style.yes_btn}` }}
                            ariaLabel="yes"
                            onClick={() => assessModalClose()}
                          />
                          <Button
                            type="button"
                            value="No"
                            classes={{ className: `btn ${style.no_btn}` }}
                            ariaLabel="no"
                            onClick={() => confirmationClose()}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Modal>
            )}
          </div>
        </>
      )}
    </>
  );
};
